export default {
  DEFAULT_COUNTRY_FLAG: 'GB',
  DEFAULT_COUNTRY_NAME: 'United Kingdom',
  DEFAULT_COUNTRY_CODE: '+44',
  DEFAULT_COUNTRY_PLACEHOLDER: '2015550123',
  DEFAULT_COUNTRY_SHORT: 'UK',
}
